(() => {
'use strict';
const script=document.querySelector('script[data-pm-app-url]');
let base;
try {
  base=new URL(script?.dataset?.pmAppUrl||'https://app.pinmarket.pl/modele/');
  if(base.protocol!=='https:')return;
}catch(_){return;}

const formFor=(link)=>{
  const form=document.querySelector('[data-ps-product] #ps-product-form');
  const table=!!document.querySelector('[data-ps-product] .pm-app-entry--prepurchase');
  // On a table page BOTH the global ribbon and "Sprawdź przed zakupem" carry
  // the exact selected Shopify variant. On other pages the global ribbon starts a new configuration.
  return form&&(link?.hasAttribute('data-pm-model-link')?table:(table||!link?.hasAttribute('data-pm-global-config')))?form:null;
};
const build=(link)=>{
  const url=new URL((link?.hasAttribute('data-pm-model-link')||link?.hasAttribute('data-pm-product-preview'))?'https://app.pinmarket.pl/modele/':base);
  ['pm_variant','variant_id','product_handle','pm_qty','pm_return','pm_mode','pm_entry'].forEach(k=>url.searchParams.delete(k));
  const form=formFor(link);
  const table=!!document.querySelector('[data-ps-product] .pm-app-entry--prepurchase');
  const preview=table&&(link?.hasAttribute('data-pm-product-preview')||link?.hasAttribute('data-pm-global-config'));
  if(form){
    const variant=form.querySelector('[name="id"]')?.value||'';
    const quantity=Number(form.querySelector('[name="quantity"]')?.value||1);
    if(!/^\d+$/.test(variant)||!Number.isInteger(quantity)||quantity<1||quantity>1000)return null;
    url.searchParams.set('pm_variant',variant);
    url.searchParams.set('variant_id',variant);
    try{const product=JSON.parse(document.querySelector('[data-ps-product-json]')?.textContent||'{}');if(/^[a-z0-9-]+$/.test(product.handle||''))url.searchParams.set('product_handle',product.handle);}catch(_){}
    url.searchParams.set('pm_qty',String(quantity));
    const back=new URL(location.href);
    back.search='';back.hash='';back.searchParams.set('variant',variant);
    url.searchParams.set('pm_return',back.href);
  }
  if(preview)url.searchParams.set('pm_mode','table-preview');
  url.searchParams.set('pm_entry',link?.hasAttribute('data-pm-global-config')?(form?'product-preview':'global-config'):'product');
  return url;
};
const refresh=()=>{
  document.querySelectorAll('[data-pm-app-link],[data-pm-model-link]').forEach(link=>{
    const url=build(link);
    if(url)link.href=url.href;
  });
};
function placeRibbon(){
  const ribbon=document.querySelector('[data-pm-global-ribbon]');
  const header=document.querySelector('.ps-header');
  if(!ribbon||!header)return;
  const section=ribbon.closest('.shopify-section')||ribbon;
  const headerSection=header.closest('.shopify-section')||header;
  if(section!==headerSection && headerSection.nextElementSibling!==section)headerSection.after(section);
}
placeRibbon();
refresh();
document.addEventListener('DOMContentLoaded',()=>{placeRibbon();refresh();});
document.addEventListener('shopify:section:load',()=>{placeRibbon();refresh();});
document.addEventListener('change',refresh);
document.addEventListener('input',refresh);
document.addEventListener('click',event=>{
  const link=event.target.closest('[data-pm-app-link],[data-pm-model-link]');
  if(!link)return;
  const form=formFor(link),url=build(link);
  if(!url||(form&&!form.reportValidity())){
    event.preventDefault();
    const error=document.querySelector('[data-pm-app-error]')||document.querySelector('[data-pm-ribbon-error]');
    if(error)error.textContent='Wybierz wariant stołu i poprawną ilość przed otwarciem aplikacji.';
    return;
  }
  link.href=url.href;
  if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true&&typeof window.gtag==='function'){
    window.gtag('event','configurator_open',{
      entry_point:link.hasAttribute('data-pm-global-config')?'config-ribbon':'product',
      item_id:url.searchParams.get('pm_variant')||'',
      view_mode:url.searchParams.get('pm_mode')||'regular'
    });
  }
},true);
})();